// BrandHeader.js

import React from 'react';

const Disclaimer = (props) => {
  return (
    <div>
        <p>{props.disclaimer}</p>
    </div>
  );
};

export default Disclaimer;
